(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('EvaluationGlucose', EvaluationGlucose);

    EvaluationGlucose.$inject = ['$resource'];

    function EvaluationGlucose ($resource) {
        var resourceUrl =  'api/evaluation-glucoses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByEvaluation': {method: 'GET', url: 'api/evaluation-glucoses/by-evaluation/:id', isArray: true}
        });
    }
})();
